// Mock data for Sparkle Property Care website

export const businessInfo = {
  name: "Sparkle Property Care Ltd",
  fullName: "Sparkle Property Care Ltd",
  registrationNumber: "Ltd"
};

export const services = [
  {
    id: 1,
    title: "Property Caretaking",
    shortDescription: "Professional property caretaking and oversight services",
    fullDescription: "Ensure your property is well-maintained and secure with our professional caretaking services. We provide reliable, experienced, and professional live-in caretakers for landlords and property management companies. Trusted care, peace of mind.",
    features: [
      "Live-in property caretakers available",
      "Experienced and professional team",
      "Enhance property value",
      "Reduce vacancy and turnover",
      "Security monitoring and peace of mind",
      "24/7 emergency response"
    ],
    icon: "shield",
    imageUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_sparkle-clean-83/artifacts/e8ncyxoo_Screenshot%202026-08-03%20221144.png"
  },
  {
    id: 2,
    title: "Commercial Cleaning Services Winnipeg",
    shortDescription: "Professional commercial office cleaning services in Winnipeg, Manitoba",
    fullDescription: "Clean spaces. Strong impressions. #1 commercial cleaning services in Winnipeg - We provide professional commercial office cleaning, janitorial services, and deep cleaning for retail spaces, office buildings, and commercial facilities throughout Winnipeg and across Manitoba. Our experienced team ensures your business makes the best first impression with standard cleaning and specialized deep cleaning services.",
    features: [
      "Commercial office cleaning Winnipeg",
      "Retail spaces deep cleaning",
      "Building common areas maintenance",
      "Floor care and polishing",
      "Washroom sanitation and disinfection",
      "Waste removal services"
    ],
    icon: "briefcase",
    imageUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_sparkle-clean-83/artifacts/sjfjcuid_Screenshot%202026-08-03%20222316.png"
  },
  {
    id: 3,
    title: "Residential Cleaning Services Winnipeg",
    shortDescription: "Professional residential deep cleaning and standard cleaning services",
    fullDescription: "Your home. Our care. #1 residential cleaning services in Winnipeg - Professional home cleaning, deep cleaning, and standard cleaning services for homeowners across Manitoba. We offer home maintenance, move-in/move-out cleaning, deep cleaning, carpet & floor care, and handyman services. Proudly serving residential communities across Winnipeg.",
    features: [
      "Residential deep cleaning Winnipeg",
      "Standard home cleaning services",
      "Move-in/move-out cleaning",
      "Carpet and floor deep cleaning",
      "Kitchen and bathroom cleaning",
      "Yard care and seasonal services"
    ],
    icon: "home",
    imageUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_sparkle-clean-83/artifacts/sascij3r_Screenshot%202026-08-03%20224222.png"
  },
  {
    id: 4,
    title: "Office Cleaning Services Winnipeg",
    shortDescription: "Professional office cleaning and janitorial services in Winnipeg, Manitoba",
    fullDescription: "A clean office. A productive team. #1 office cleaning services in Winnipeg - Professional office cleaning, deep cleaning, and standard cleaning for offices across Manitoba. We provide daily office clean services, desk sanitization, and comprehensive janitorial services. Our specialized office cleaning ensures a healthy, productive workspace for your team. Proudly serving businesses across Winnipeg.",
    features: [
      "Daily office cleaning Winnipeg",
      "Desks and workstations deep cleaning",
      "Washroom sanitation and disinfection",
      "Kitchen and break areas cleaning",
      "Office disinfection services",
      "Standard and deep cleaning options"
    ],
    icon: "briefcase",
    imageUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_sparkle-clean-83/artifacts/8vav0xce_Screenshot%202026-08-03%20222345.png"
  },
  {
    id: 5,
    title: "Delivery Services",
    shortDescription: "Reliable delivery and moving services",
    fullDescription: "Professional delivery and move-in/move-out services for businesses and individuals throughout Winnipeg. From same-day deliveries to full residential moves, we provide fast, reliable, and secure transportation solutions.",
    features: [
      "Move-in/move-out services",
      "Same-day delivery available",
      "Residential and commercial moves",
      "Secure handling and transport",
      "Professional moving vans",
      "Track and trace"
    ],
    icon: "truck",
    imageUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_sparkle-clean-83/artifacts/7uesvun8_Screenshot%202026-08-03%20221013.png"
  },
  {
    id: 6,
    title: "Property Management",
    shortDescription: "Complete property management and maintenance solutions",
    fullDescription: "Well managed. Well maintained. Professional property management services to keep your investment properties in top condition. We handle tenant relations, maintenance coordination, property inspections, and provide 24/7 emergency support. Proudly serving communities across Canada.",
    features: [
      "Tenant relations",
      "Maintenance coordination",
      "Property inspections",
      "Rent collection",
      "24/7 emergency support",
      "Detailed property reports"
    ],
    icon: "clipboardList",
    imageUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_sparkle-clean-83/artifacts/lghbq3f9_Screenshot%202026-08-03%20223652.png"
  },
  {
    id: 7,
    title: "Post-Construction Cleaning Winnipeg",
    shortDescription: "Professional post construction cleaning and deep cleaning services in Winnipeg",
    fullDescription: "Specialized post-construction cleaning and deep cleaning services in Winnipeg to remove dust, debris, and construction residue. We provide thorough post construction cleaning for new builds and renovations throughout Manitoba. Our experienced team makes your newly constructed or renovated space move-in ready and spotless with comprehensive deep cleaning services.",
    features: [
      "Post construction cleaning Winnipeg",
      "Dust and debris removal",
      "Window and glass deep cleaning",
      "Floor cleaning and polishing",
      "Paint and sticker removal",
      "Construction waste disposal coordination"
    ],
    icon: "hammer",
    imageUrl: "https://images.unsplash.com/photo-1529792083865-d23889753466?w=800&h=600&fit=crop"
  },
  {
    id: 8,
    title: "Maintenance Services",
    shortDescription: "Comprehensive maintenance for residential and commercial properties",
    fullDescription: "Keep your property in excellent condition with our comprehensive maintenance services. From minor repairs to preventative maintenance, we ensure your property remains safe, functional, and well-maintained.",
    features: [
      "Regular maintenance checks",
      "Minor repairs and fixes",
      "Seasonal maintenance services",
      "Plumbing and electrical coordination",
      "HVAC maintenance",
      "Preventative maintenance programs"
    ],
    icon: "wrench",
    imageUrl: "https://images.unsplash.com/photo-1505798577917-a65157d3320a?w=800&h=600&fit=crop"
  },
  {
    id: 9,
    title: "Snow Removal",
    shortDescription: "Reliable snow and ice management for Winnipeg winters",
    fullDescription: "Professional snow removal services to keep your property safe and accessible throughout Manitoba's harsh winters. We provide prompt, reliable service for residential, commercial, and multi-unit properties.",
    features: [
      "Driveway and parking lot clearing",
      "Sidewalk and walkway snow removal",
      "Ice management and salting",
      "24/7 emergency snow removal",
      "Seasonal contracts available",
      "Commercial and residential service"
    ],
    icon: "snowflake",
    imageUrl: "https://images.unsplash.com/photo-1611194625888-3c6621587ee4?w=800&h=600&fit=crop"
  },
  {
    id: 10,
    title: "Warehouse Cleaning",
    shortDescription: "Industrial-grade cleaning for warehouses and facilities",
    fullDescription: "Specialized warehouse and industrial facility cleaning services. We handle large-scale cleaning projects with efficiency and attention to safety standards.",
    features: [
      "Floor sweeping and scrubbing",
      "High-dusting and ceiling cleaning",
      "Loading dock cleaning",
      "Equipment cleaning",
      "Safety compliance cleaning",
      "Flexible scheduling"
    ],
    icon: "package",
    imageUrl: "https://images.unsplash.com/photo-1601602279590-989e63980bda?w=800&h=600&fit=crop"
  },
  {
    id: 11,
    title: "Restoration Services",
    shortDescription: "Property restoration and recovery services",
    fullDescription: "Professional restoration services for properties affected by water damage, fire, or other disasters. We help restore your property to its pre-loss condition.",
    features: [
      "Water damage restoration",
      "Fire and smoke damage cleanup",
      "Mold remediation",
      "Emergency response 24/7",
      "Content cleaning and restoration",
      "Insurance coordination"
    ],
    icon: "refresh",
    imageUrl: "https://images.unsplash.com/photo-1710185291260-bf480d5f08c4?w=800&h=600&fit=crop"
  },
  {
    id: 12,
    title: "Construction Services",
    shortDescription: "General construction and renovation services",
    fullDescription: "Quality construction services for residential and commercial projects. From minor renovations to major construction projects, we deliver quality workmanship.",
    features: [
      "Residential renovations",
      "Commercial construction",
      "Remodeling projects",
      "Custom builds",
      "Project management",
      "Licensed and insured"
    ],
    icon: "hammer",
    imageUrl: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=800&h=600&fit=crop"
  },
  {
    id: 13,
    title: "Roofing Services",
    shortDescription: "Professional roofing installation and repair",
    fullDescription: "Complete roofing services including installation, repair, and maintenance. Protect your property with quality roofing solutions built for Manitoba weather.",
    features: [
      "Roof installation",
      "Roof repairs and maintenance",
      "Inspection services",
      "Emergency repairs",
      "Ice dam removal",
      "Licensed and insured"
    ],
    icon: "home",
    imageUrl: "https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1?w=800&h=600&fit=crop"
  },
  {
    id: 14,
    title: "Window Cleaning",
    shortDescription: "Professional window cleaning for homes and businesses",
    fullDescription: "Professional window cleaning services for residential and commercial properties. Keep your windows spotless and streak-free year-round.",
    features: [
      "Interior and exterior cleaning",
      "High-rise window cleaning",
      "Screen cleaning",
      "Track and frame cleaning",
      "Streak-free results",
      "Residential and commercial"
    ],
    icon: "sparkles",
    imageUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_sparkle-clean-83/artifacts/sascij3r_Screenshot%202026-08-03%20224222.png"
  },
  {
    id: 15,
    title: "Painting Services",
    shortDescription: "Professional interior and exterior painting",
    fullDescription: "Fresh coat. Lasting impression. Professional painting services for residential and commercial properties. From interior walls to exterior facades, we deliver quality finishes with attention to detail. Proudly serving communities across Canada.",
    features: [
      "Interior painting",
      "Exterior painting",
      "Commercial and residential",
      "Surface preparation",
      "Detail-oriented finish",
      "Color consultation available"
    ],
    icon: "sparkles",
    imageUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_sparkle-clean-83/artifacts/jvy9aqvs_Screenshot%202026-08-03%20223707.png"
  },
  {
    id: 16,
    title: "Carpet Cleaning",
    shortDescription: "Professional carpet and upholstery cleaning services",
    fullDescription: "Deep clean and refresh your carpets with our professional carpet cleaning services. We use industry-leading equipment and eco-friendly solutions to remove dirt, stains, and allergens, extending the life of your carpets and improving indoor air quality.",
    features: [
      "Deep carpet cleaning",
      "Stain and odor removal",
      "Upholstery cleaning",
      "Pet stain treatment",
      "Fast drying time",
      "Eco-friendly solutions"
    ],
    icon: "sparkles",
    imageUrl: "https://images.unsplash.com/photo-1742483359033-13315b247c74?w=800&h=600&fit=crop"
  },
  {
    id: 17,
    title: "Airbnb Cleaning",
    shortDescription: "Specialized cleaning for short-term rentals and Airbnb properties",
    fullDescription: "Keep your Airbnb and short-term rental properties guest-ready with our specialized cleaning services. We provide fast, thorough turnovers between guests, ensuring 5-star reviews and happy guests every time. Flexible scheduling to match your booking calendar.",
    features: [
      "Fast turnaround between guests",
      "Complete property cleaning",
      "Linen and towel service coordination",
      "Restocking essentials",
      "Detailed inspection and reporting",
      "Flexible scheduling"
    ],
    icon: "home",
    imageUrl: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&h=600&fit=crop"
  },
  {
    id: 18,
    title: "Waste Management",
    shortDescription: "Professional garbage pickup and waste disposal services",
    fullDescription: "Reliable waste management and garbage collection services for residential, commercial, and construction sites. We handle all types of waste pickup and ensure proper disposal, keeping your property clean and compliant with local regulations.",
    features: [
      "Regular garbage pickup",
      "Construction waste removal",
      "Bulk item disposal",
      "Recycling coordination",
      "Commercial waste management",
      "Flexible scheduling"
    ],
    icon: "trash",
    imageUrl: "https://images.unsplash.com/photo-1574974671999-24b7dfbb0d53?w=800&h=600&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Thompson",
    location: "Winnipeg, MB",
    rating: 5,
    text: "Sparkle Property Care has been amazing since I started using them a few months ago. They're always professional, thorough, and trustworthy. Highly recommend!",
    service: "Residential Cleaning"
  },
  {
    id: 2,
    name: "Michael Chen",
    location: "Winnipeg, MB",
    rating: 5,
    text: "As a property manager, I rely on Sparkle for all our unit turnovers. They're efficient, reliable, and do excellent work every time.",
    service: "Property Management"
  },
  {
    id: 3,
    name: "Jennifer Martinez",
    location: "Winnipeg, MB",
    rating: 5,
    text: "Our office has never looked better! The team is professional and works around our schedule. Great service!",
    service: "Commercial Cleaning"
  },
  {
    id: 4,
    name: "David Kowalski",
    location: "Winnipeg, MB",
    rating: 5,
    text: "Their snow removal service has been a lifesaver this winter! Always prompt and thorough, even during heavy snowfalls.",
    service: "Snow Removal"
  },
  {
    id: 5,
    name: "Lisa Anderson",
    location: "Winnipeg, MB",
    rating: 5,
    text: "The maintenance team is fantastic! Quick response times and quality work. They've helped keep my rental properties in great shape.",
    service: "Housing Maintenance"
  }
];

export const serviceAreas = [
  "Downtown Winnipeg",
  "St. Vital",
  "River Heights",
  "Osborne Village",
  "Fort Garry",
  "Transcona",
  "Charleswood",
  "St. James"
];

export const contactInfo = {
  phone: "204-294-6802",
  email: "propertycaresparkle@gmail.com",
  address: "Winnipeg, Manitoba, Canada",
  hours: {
    availability: "24/7",
    description: "Available 24 Hours a Day, 7 Days a Week"
  },
  googleReviewLink: "https://www.google.com/search?q=sparkle+property+care+ltd"
};

// Mock function to save booking requests (using localStorage)
export const saveBookingRequest = (bookingData) => {
  const bookings = JSON.parse(localStorage.getItem('bookings') || '[]');
  const newBooking = {
    ...bookingData,
    id: Date.now(),
    status: 'pending',
    createdAt: new Date().toISOString()
  };
  bookings.push(newBooking);
  localStorage.setItem('bookings', JSON.stringify(bookings));
  return newBooking;
};

// Mock function to get all bookings
export const getBookings = () => {
  return JSON.parse(localStorage.getItem('bookings') || '[]');
};
